export default __webpack_public_path__ + "static/media/business_show_9.40408544.png";